import { dbRef } from "../../db-ref";
import { zServiceProject } from "./service-project-resource";
import { ResourceSubPipeline } from "../../utils";
import { getUserSnippetPipeline } from "../users/user-snippet-resource";

const serviceProjectRatingsPipeline: ResourceSubPipeline = {
  mainStages: [
    {
      $lookup: {
        from: dbRef.review.collection,
        localField: "_id",
        foreignField: "serviceProjectId",
        as: "projectReviews",
      },
    },
    {
      $addFields: {
        clientReview: {
          $filter: {
            input: "$projectReviews",
            as: "doc",
            cond: { $eq: ["$$doc.reviewerId", "$clientId"] },
          },
        },
      },
    },
    { $unwind: { path: "$clientReview", preserveNullAndEmptyArrays: true } },
    {
      $addFields: {
        professionalReview: {
          $filter: {
            input: "$projectReviews",
            as: "doc",
            cond: { $eq: ["$$doc.reviewerId", "$professionalId"] },
          },
        },
      },
    },
    { $unwind: { path: "$professionalReview", preserveNullAndEmptyArrays: true } },
  ],
  projectStage: {
    clientRating: "$clientReview.rating",
    professionalRating: "$professionalReview.rating",
  },
};

const serviceProjectTasksPipeline: ResourceSubPipeline = {
  mainStages: [
    {
      $lookup: {
        from: "tasks",
        let: { serviceProjectId: "$_id" },
        pipeline: [
          { $match: { $expr: { $eq: ["$linkedId", "$$serviceProjectId"] } } },
          { $match: { linkedTo: dbRef.serviceProject.collection } },
          // for all tasks that match the above condition, sum into `total` and `completed` tasks
          {
            $group: {
              _id: null,
              total: { $sum: 1 },
              completed: { $sum: { $cond: [{ $eq: ["$completionInfo.isComplete", true] }, 1, 0] } },
            },
          },
        ],
        as: "tasksInfo",
      },
    },
    { $unwind: { path: "$tasksInfo", preserveNullAndEmptyArrays: true } },
    // `tasksInfo` will be [] if no tasks are found: replace it with default values
    {
      $addFields: {
        tasksInfo: { $ifNull: ["$tasksInfo", { total: 0, completed: 0 }] },
      },
    },
  ],
  projectStage: {
    "tasksInfo.total": 1,
    "tasksInfo.completed": 1,
  },
};

export function getServiceProjectPipelines() {
  const clientPipeline = getUserSnippetPipeline("clientId", "clientDoc");
  const professionalPipeline = getUserSnippetPipeline("professionalId", "professionalDoc");

  return {
    _z: zServiceProject,
    mainStages: [
      ...clientPipeline.mainStages,
      ...professionalPipeline.mainStages,
      ...serviceProjectRatingsPipeline.mainStages,
      ...serviceProjectTasksPipeline.mainStages,
    ],
    projectStage: {
      _id: 1,
      serviceId: 1,
      serviceDetails: 1,
      servicePackageId: 1,
      servicePackageDetails: 1,
      orderNumber: 1,
      status: 1,
      statusUpdates: 1,
      closingReason: 1,
      acceptedAt: 1,
      dueAt: 1,
      deliverablesCompletion: 1,
      createdAt: 1,
      updatedAt: 1,
      ...clientPipeline.projectStage,
      ...professionalPipeline.projectStage,
      ...serviceProjectRatingsPipeline.projectStage,
      ...serviceProjectTasksPipeline.projectStage,
    },
  };
}
